// extracted by mini-css-extract-plugin
module.exports = {"tagSection":"_3b760da","standingsSkeleton":"_c95efb4","titleSkeleton":"_b59bc5a","textSkeleton":"_c5cc942","tableSkeleton":"_8078c2a"};